import { ICellRenderer, ICellRendererParams } from "ag-grid-enterprise";
import { ChangeDetectionStrategy, Component, signal } from "@angular/core";
import { IImageCellRendererParams } from "./iimage-cell-renderer-params";
import { NgClass } from "@angular/common";
import { IconSpriteModule } from "ng-svg-icon-sprite";
import { ImageCellViewboxPipe } from "../pipes/image-cell-viewbox.pipe";

@Component({
    selector: 'image-cell-renderer',
    templateUrl: 'image-cell-renderer.component.html',
    styleUrls: ['./image-cell-renderer.component.scss'],
    imports: [
    NgClass,
    IconSpriteModule,
    ImageCellViewboxPipe
],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImageCellRendererComponent implements ICellRenderer<IImageCellRendererParams> {

  params!: any;
  public imageCellParams = signal<Array<IImageCellRendererParams>>([]);
  public rendererIconURL!: string;
  public rendererIconURLs: Array<string> = [];
  public text!: string;
  public textCssClass!: string;
  public imageCssClass!: string;
  public imageTitle: string = '';
  public iconHeight: string = '';
  public iconWidth: string = ''
  public viewBox: string = '';
  public isYellowFlag: boolean = false;
  private readonly RED_FLAG_HEIGHT: string = "17px";
  private readonly RED_FLAG_WIDTH: string = "17px";
  private readonly YELLOW_FLAG_HEIGHT: string = "19px";
  private readonly YELLOW_FLAG_WIDTH: string = "15px";
  private readonly CHECK_HEIGHT: string = "13px";
  private readonly CHECK_WIDTH: string = "23px";
  private readonly NONBILL_HEIGHT: string = "16px";
  private readonly NONBILL_WIDTH: string = "16px";

  agInit(params: any): void {
    this.params = params;
    this.setParameters();
  }

  setParameters() {
    if (this.params.imageCellParams) {
      const updatedParams = (this.params.imageCellParams as Array<IImageCellRendererParams>).map(param => {
        const updatedParam: IImageCellRendererParams = { ...param };
        this.setHeightWidthViewBox(updatedParam);
        updatedParam.rendererImageFilename = updatedParam.rendererImageFilename ? "assets/sprites/sprite.svg#" + updatedParam.rendererImageFilename.replace(".svg", "") : "";
        const textFieldName = updatedParam.textFieldName;
        updatedParam.text = this.params.data != null ? this.params.data[textFieldName] : '';
        updatedParam.imageTitle = updatedParam.imageTitle != '' && updatedParam.imageTitle != null ? updatedParam.imageTitle : updatedParam.text;
        return updatedParam;
      });
      this.imageCellParams.set(updatedParams);
    }
  }

  private setHeightWidthViewBox(param: IImageCellRendererParams): void {
    switch (param.rendererImageFilename) {
      case "icon-red-flag-light-bg.svg":
        param.iconHeight = this.RED_FLAG_HEIGHT;
        param.iconWidth = this.RED_FLAG_WIDTH;
        break;
      case "icon-yellow-flag-grid.svg":
        param.iconHeight = this.YELLOW_FLAG_HEIGHT;
        param.iconWidth = this.YELLOW_FLAG_WIDTH;
        param.isYellowFlag = true;
        break;
      case "icon-action-checks.svg":
        param.iconHeight = this.CHECK_HEIGHT;
        param.iconWidth = this.CHECK_WIDTH;
        break;

      case "icon-nonbill.svg":
      case "icon-nonbill":
        param.iconHeight = this.NONBILL_HEIGHT;
        param.iconWidth = this.NONBILL_WIDTH;
        break;

      default:
        console.log("Missed case in image-cell-renderer.component > setHeightWidth, rendererImageFilename = " + param.rendererImageFilename);
    }
    this.viewBox = "0 0 " + this.iconWidth.replace("px", "") + " " + this.iconHeight.replace("px", "");
  }

  refresh(params: IImageCellRendererParams): boolean {
    this.params = params;
    this.setParameters();
    return true;
  }
}
